// extracted by mini-css-extract-plugin
var _1 = "ReorderSnapshot-module__borderedContainer--gEFMg";
var _2 = "ReorderSnapshot-module__draggedImageGhost--fX8lA";
var _3 = "ReorderSnapshot-module__embedContainer--B9QT0";
export { _1 as "borderedContainer", _2 as "draggedImageGhost", _3 as "embedContainer" }
